// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".time-line .subtitle[data-v-d8722eec] {\n  font-size: 20px;\n  letter-spacing: 4px;\n}\n@media screen and (max-width: 414px) {\n.time-line .subtitle[data-v-d8722eec] {\n    font-size: 15px;\n    letter-spacing: 3px;\n}\n}", ""]);
// Exports
module.exports = exports;
